import { DocumentNode } from "graphql"
import { getOperationName } from "apollo-link"

export const getOperationNames = (refetches: DocumentNode[]): string[] => {
    const operationNames: string[] = []
    refetches.forEach(refetch => {
        const op = getOperationName(refetch)
        if (op) operationNames.push(op)
    })
    return operationNames
}
